export default "__VITE_ASSET__C85itxuG__"